import { IconButtonShape, IconButtonSizes, IconButtonVariants } from './types';
import styles from './IconButton.module.scss';
import cx from 'classnames';
import { sizeToIconSizeMap, variantIconColorMap } from './constants';
import { IconSize } from '@icons/types';

export const getIconBtnSizeShapeStyle = (size: IconButtonSizes, shape: IconButtonShape) => {
    return cx(styles[size], styles[shape]);
};

export const getIconBtnVariantStyle = (variant: IconButtonVariants) => {
    return styles[variant];
};

export const getIconColor = (variant: IconButtonVariants) => {
    return variantIconColorMap[variant];
};

export const getIconSize = (size: IconButtonSizes): IconSize => {
    return sizeToIconSizeMap[size];
};
